<form [formGroup]="expenseForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()" class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
    <ms-page-title />

    <!-- Two Column Layout -->
    <div class="row g-4 mb-5">
        <!-- Left Column -->
        <div class="col-md-6">
            <!-- Payee Name -->
            <ms-input-label [isRequired]="isFieldRequired(expenseForm, 'vendorName')" [labelText]="'Payee Name'" />
            <input
                type="text"
                id="vendorName"
                formControlName="vendorName"
                [required]="isFieldRequired(expenseForm, 'vendorName')"
                maxlength="250"
                class="form-control"
                [class.is-invalid]="expenseForm.get('vendorName')?.invalid && expenseForm.get('vendorName')?.touched"
                [class.is-valid]="expenseForm.get('vendorName')?.valid && expenseForm.get('vendorName')?.touched && expenseForm.get('vendorName')?.value !== ''" />
            @if (expenseForm.get('vendorName')?.invalid && expenseForm.get('vendorName')?.touched) {
                <div class="error-messages">
                    @if (expenseForm.get('vendorName')?.errors?.['required']) {
                        <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpensePayeeNameRequired }}</p>
                    }
                    @if (expenseForm.get('vendorName')?.errors?.['minlength']) {
                        <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpensePayeeNameMinLength }}</p>
                    }
                    @if (expenseForm.get('vendorName')?.errors?.['maxlength']) {
                        <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpensePayeeNameMaxLength }}</p>
                    }
                </div>
            }

            <!-- Paid Date -->
            <ms-input-label [isRequired]="isFieldRequired(expenseForm, 'paidDate')" [labelText]="'Date Paid'" class="mt-3" />
            <input
                type="date"
                id="paidDate"
                formControlName="paidDate"
                [required]="isFieldRequired(expenseForm, 'paidDate')"
                class="form-control"
                [class.is-invalid]="expenseForm.get('paidDate')?.invalid && expenseForm.get('paidDate')?.touched"
                [class.is-valid]="expenseForm.get('paidDate')?.valid && expenseForm.get('paidDate')?.touched" />
            @if (expenseForm.get('paidDate')?.invalid && expenseForm.get('paidDate')?.touched) {
                <div class="error-messages">
                    @if (expenseForm.get('paidDate')?.errors?.['required']) {
                        <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpensePaidDateRequired }}</p>
                    }
                    @if (expenseForm.get('paidDate')?.errors?.['noFutureDate']) {
                        <p class="text-danger text-start pt-1 mb-0">{{ expenseForm.get('paidDate')?.errors?.['noFutureDate'].message }}</p>
                    }
                </div>
            }

            <!-- Amount Paid -->
            <ms-input-label [isRequired]="isFieldRequired(expenseForm, 'amount')" [labelText]="'Amount Paid'" class="mt-3" />
            <ms-amount-input formControlName="amount" />

            <!-- Check/Reference # -->
            <ms-input-label [labelText]="'Check/Reference #'" class="mt-3" />
            <input
                type="text"
                id="referenceNumber"
                formControlName="referenceNumber"
                maxlength="30"
                class="form-control"
                [class.is-invalid]="expenseForm.get('referenceNumber')?.invalid && expenseForm.get('referenceNumber')?.touched"
                [class.is-valid]="expenseForm.get('referenceNumber')?.valid && expenseForm.get('referenceNumber')?.touched && expenseForm.get('referenceNumber')?.value !== ''" />
            @if (expenseForm.get('referenceNumber')?.invalid && expenseForm.get('referenceNumber')?.touched) {
                <div class="error-messages">
                    @if (expenseForm.get('referenceNumber')?.errors?.['maxlength']) {
                        <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpenseReferenceNumberMaxLength }}</p>
                    }
                    @if (expenseForm.get('referenceNumber')?.errors?.['pattern']) {
                        <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpenseReferenceNumberPattern }}</p>
                    }
                </div>
            }

        </div>

        <!-- Right Column -->
        <div class="col-md-6">
            <!-- Expense Type -->
            <ms-input-label [isRequired]="isFieldRequired(expenseForm, 'expenseAccount')" [labelText]="'Expense Type'" />
            <ms-chart-of-account-typeahead
                #expenseAccountTypeahead
                id="expenseAccount"
                formControlName="expenseAccount"
                [organizationId]="userSessionService.activeOrganization()?.organizationId"
                [categories]="[ChartOfAccountCategory.Expenses]"
                [invalid]="expenseForm.get('expenseAccount')?.invalid && expenseForm.get('expenseAccount')?.touched ? true : false" />
            @if (expenseAccountTypeahead.results().length === 0 && !expenseAccountTypeahead.isSearching()) {
                <p class="text-warning small mb-0 mt-1">
                    <fa-duotone-icon icon="triangle-exclamation" class="me-1" secondaryOpacity="0.3" />
                    {{ FormValidatorMessages.ExpenseTypeNoAccountsAvailable }}
                </p>
            } @else if (expenseForm.get('expenseAccount')?.invalid && expenseForm.get('expenseAccount')?.touched) {
                <div class="error-messages">
                    <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpenseTypeRequired }}</p>
                </div>
            }

            <!-- Liability Account -->
            <ms-input-label [isRequired]="isFieldRequired(expenseForm, 'liabilityAccount')" [labelText]="'Liability Account'" class="mt-3" />
            <ms-chart-of-account-typeahead
                #liabilityAccountTypeahead
                id="liabilityAccount"
                formControlName="liabilityAccount"
                [organizationId]="userSessionService.activeOrganization()?.organizationId"
                [categories]="[ChartOfAccountCategory.Liabilities]"
                [invalid]="expenseForm.get('liabilityAccount')?.invalid && expenseForm.get('liabilityAccount')?.touched ? true : false" />
            @if (liabilityAccountTypeahead.results().length === 0 && !liabilityAccountTypeahead.isSearching()) {
                <p class="text-warning small mb-0 mt-1">
                    <fa-duotone-icon icon="triangle-exclamation" class="me-1" secondaryOpacity="0.3" />
                    {{ FormValidatorMessages.ExpenseLiabilityAccountNoAccountsAvailable }}
                </p>
            } @else if (expenseForm.get('liabilityAccount')?.invalid && expenseForm.get('liabilityAccount')?.touched) {
                <div class="error-messages">
                    <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpenseLiabilityAccountRequired }}</p>
                </div>
            }

            <!-- Notes -->
            <ms-input-label [labelText]="'Notes'" class="mt-3" />
            <textarea
                id="description"
                formControlName="description"
                maxlength="500"
                rows="3"
                class="form-control"
                [class.is-valid]="expenseForm.get('description')?.valid && expenseForm.get('description')?.touched && expenseForm.get('description')?.value !== ''"></textarea>
            @if (expenseForm.get('description')?.errors?.['maxlength'] && expenseForm.get('description')?.touched) {
                <div class="error-messages">
                    <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.ExpenseDescriptionMaxLength }}</p>
                </div>
            }
        </div>
    </div>

    <!-- Form Action Buttons -->
    <div class="d-flex flex-column flex-sm-row justify-content-end gap-2 mt-3 align-items-stretch align-items-sm-center">
        <button type="button" class="btn btn-ms-secondary order-2 order-sm-1" (click)="onCancel()">
            Cancel
        </button>
        <button type="submit" class="btn btn-primary order-1 order-sm-2">
            @if (isSubmitting) {
                <div class="spinner-border text-light spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            } @else {
                Submit
            }
        </button>
    </div>
</form>

<ms-confirmation-modal #expenseConfirmationModalRef modalId="expenseConfirmationModal"
    confirmButtonText="Leave" cancelButtonText="Stay"
    (confirmed)="confirmationConfirmFunction()"
    (cancelled)="confirmationCancelFunction()"
/>

<ms-info-modal #expenseInfoModalRef modalId="expenseInfoModal" (onConfirm)="infoModalConfirmed()" />
